namespace TabAurous.Administration {
    export interface AuthorizedVouchersRow {
        AuthorizationId?: number;
        LoginUserId?: number;
        AuthorizedUserId?: number;
        VoucherNo?: string;
        VoucherTypeId?: number;
        AuthorizationDate?: string;
        Remark?: string;
    }

    export namespace AuthorizedVouchersRow {
        export const idProperty = 'AuthorizationId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'Administration.AuthorizedVouchers';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            AuthorizationId = "AuthorizationId",
            LoginUserId = "LoginUserId",
            AuthorizedUserId = "AuthorizedUserId",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            AuthorizationDate = "AuthorizationDate",
            Remark = "Remark"
        }
    }
}
